<template>
  <div class="offer-invite-management">
    <el-tabs v-model="activePageNum" ref="tabs" class="page-tab" @tab-click="handlePageTabClick">
      <el-tab-pane
        v-for="tab in tabList"
        :key="tab.pageNum"
        :label="tab.label"
        :name="tab.pageNum"
      >
      </el-tab-pane>
    </el-tabs>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { OFFER_LETTER_PAGE_TYPE } from '@/constant/company'

export default {
  components: {
  },
  data () {
    return {
      i18nPrefix: 'admin.company.offerLetterInviteRecordManagement',
      activePageNum: null
    }
  },
  computed: {
    pageType () {
      return this.$route.meta.pageType
    },
    tabList () {
      const i18nPrefix = this.i18nPrefix
      const basePath = '/v-admin/offer-letter-management'

      const list = [
        {
          pageNum: OFFER_LETTER_PAGE_TYPE.INVITE_RECORD,
          label: this.$t(`${i18nPrefix}.label.offerLetterInviteRecord`),
          path: `${basePath}/invite/list`,
          permission: 'PERM_OFFER_INITIATE'
        },
        {
          pageNum: OFFER_LETTER_PAGE_TYPE.FIELD,
          label: this.$t(`${i18nPrefix}.label.offerLetterField`),
          path: `${basePath}/field/list`,
          permission: 'PERM_OFFER_CUSTOM_FIELD_MANAGEMENT'
        },
        {
          pageNum: OFFER_LETTER_PAGE_TYPE.TEMPLATE,
          label: this.$t(`${i18nPrefix}.label.offerLetterTemplate`),
          path: `${basePath}/template/list`,
          permission: 'PERM_OFFER_TEMPLATE_MANAGEMENT'
        }
      ]
      return _.filter(list, item => {
        if (item.permission) {
          return this.hasAnyPermission(item.permission)
        }
        return true
      })
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    initPage () {
      if (this.pageType) {
        this.activePageNum = this.pageType
      } else {
        this.activePageNum = this.tabList[0].pageNum
        this.handlePageTabClick()
      }
    },
    resizeTab () {
      const currentTab = this.activePageNum
      this.activePageNum = null
      this.$nextTick(() => {
        this.activePageNum = currentTab
      })
    },
    handlePageTabClick () {
      const tab = _.find(this.tabList, { pageNum: this.activePageNum })
      this.$router.push(tab.path)
    }
  },
  watch: {
    pageType () {
      this.initPage()
    },
    '$i18n.locale' () {
      this.resizeTab()
    }
  }
}
</script>

<style lang="scss" scoped>
.offer-invite-management {
  .page-tab {
    ::v-deep {
      .el-tabs__item {
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
}
</style>
